const getSearchParams = ({ search_type }) => {

  return {
    // availability: 11, // Double check
    per_page: search_type === "map" ? 300 : 12,
    fields: [
      "id",
      "coordinates",
      "programme",
      "site_name",
      "site_use",
      "site_status",
      "site_sqm",
      "gfa_sqm",
      "expected_tender_launch_date",
      "tender_close_date",
      "tender_award_date",
      "success_tender_price",
      "success_tender_price_psf",
      "developer",
      "project_name",
      "expected_top_year",
      "top_date",
      "geojson"
    ],
    order: {
      orderby_custom: [
        "sort_date"
      ],
      orderby_isnull_custom: [
        "0"
      ],
      order_custom: [
        "DESC"
      ],
      ordertype_custom: [
        "DATE"
      ]
    }
  }

}

const getSearchParamsHook = () => {

  const searchParamsHook = (params) => {

    let newParams = { ...params };
    if (params.programme) {
      if (params.programme !== "All") {
        newParams["programme[compare=LIKE]"] = params.programme;
      }
      delete newParams.programme;
    }

    return newParams;

  }

  return searchParamsHook;

}

const getSearchResultsHook = () => {

  const searchResultsHook = async (res) => {
    return res;
  }

  return searchResultsHook;

}

export { getSearchParams, getSearchParamsHook, getSearchResultsHook };
